import _toArray from "@babel/runtime/helpers/toArray";
import React from 'react';
import Badge from '@atlaskit/badge';
import { BadgeWrapper, Container, LabelValueWrapper } from './styled';
export var hasValue = function hasValue(value) {
  return Array.isArray(value) ? value.length > 0 : !!value;
};
export var formatLabel = function formatLabel() {
  var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (!value || !hasValue(value)) {
    return label;
  }

  var _value$map = value.map(function (v) {
    var _v$label;

    return (_v$label = v.label) !== null && _v$label !== void 0 ? _v$label : '';
  }),
      _value$map2 = _toArray(_value$map),
      firstValue = _value$map2[0],
      otherValues = _value$map2.slice(1);

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("strong", null, label, ":"), /*#__PURE__*/React.createElement(LabelValueWrapper, null, firstValue, otherValues.length > 0 && /*#__PURE__*/React.createElement(BadgeWrapper, null, /*#__PURE__*/React.createElement(Badge, null, "+".concat(otherValues.length)))));
};